export interface DefaultPageOption {
  value: string;
  label: string;
  icon?: string;
}

// אפשרויות עמודי ברירת המחדל
export const DEFAULT_PAGE_OPTIONS: DefaultPageOption[] = [
  {
    value: '/chats',
    label: 'כל השיחות'
  },
  {
    value: '/chats/my',
    label: 'השיחות שלי'
  },
  {
    value: '/chats/not-my',
    label: 'לא השיחות שלי'
  },
  {
    value: '/chats/unassigned',
    label: 'שיחות לא משויכות'
  },
  {
    value: '/contacts/chat',
    label: 'אנשי קשר'
  },
  {
    value: '/calendar',
    label: 'יומן'
  },
  {
    value: '/templates/list',
    label: 'תבניות הודעות'
  },
  {
    value: '/labels',
    label: 'תגיות'
  },
  {
    value: '/drive/images',
    label: 'ספריית קבצים'
  },
  {
    value: '/statistics',
    label: 'מדדים וגרפים'
  },
  {
    value: '/users',
    label: 'משתמשים'
  },
  {
    value: '/broadcasts/planned',
    label: 'תפוצה'
  },
  {
    value: '/workflows',
    label: 'בוטים'
  },
  {
    value: '/ai-support',
    label: 'בינה מלאכותית'
  },
  {
    value: '/webhooks',
    label: 'וובהוקים ואינטגרציות'
  }
];

// מפתח ב-localStorage
export const DEFAULT_HOME_PAGE_KEY = 'defaultHomePage';

// עמוד ברירת המחדל הקבוע (כמו שהיה קודם)
export const FALLBACK_DEFAULT_PAGE = '/chats';

/**
 * שומר את עמוד ברירת המחדל ב-localStorage
 */
export const saveDefaultHomePage = (path: string): void => {
  try {
    localStorage.setItem(DEFAULT_HOME_PAGE_KEY, path);
  } catch (error) {
    console.error('Error saving default home page:', error);
  }
};

/**
 * טוען את עמוד ברירת המחדל מ-localStorage
 */
export const getDefaultHomePage = (): string => {
  try {
    const savedPage = localStorage.getItem(DEFAULT_HOME_PAGE_KEY);
    return savedPage || FALLBACK_DEFAULT_PAGE;
  } catch (error) {
    console.error('Error loading default home page:', error);
    return FALLBACK_DEFAULT_PAGE;
  }
};

/**
 * מוחק את הגדרת עמוד ברירת המחדל (חזרה לברירת מחדל)
 */
export const clearDefaultHomePage = (): void => {
  try {
    localStorage.removeItem(DEFAULT_HOME_PAGE_KEY);
  } catch (error) {
    console.error('Error clearing default home page:', error);
  }
};

/**
 * בודק אם עמוד מסוים הוא עמוד תקני
 */
export const isValidDefaultPage = (path: string): boolean => {
  return DEFAULT_PAGE_OPTIONS.some(option => option.value === path);
}; 